const kformBuilderOptionInputFormatController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.formats = [
		{
			value: 'plain',
			title: 'Plain',
		},
		{
			value: 'html',
			title: 'HTML',
		},
		{
			value: 'raw',
			title: 'Raw (Insecure)',
		},
	];

	if (!$scope.component.inputFormat) {
		if ($scope.component.type === 'textarea') {
			$scope.$watch('component.wysiwyg', (/** @type {boolean} */ wysiwyg) => {
				$scope.component.inputFormat = wysiwyg ? 'html' : 'plain';
			});
		}

		$scope.component.inputFormat = 'plain';
	}
};

export default kformBuilderOptionInputFormatController;
